import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M12 20l7 -12h-14z","key":"svg-1"}]]

const IconCircleTriangle = createReactComponent('outline', 'circle-triangle', 'CircleTriangle', __iconNode);

export default IconCircleTriangle;